import React, { useRef } from "react";
import config from "../../../contexts/ConfigContext";
import { CommonLibrary } from "../../../contexts/CommonContext";
import { Row, Col } from "react-bootstrap";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {
  GridColumnMenuProps,
  GridColumnMenuFilter  
} from "@progress/kendo-react-grid";
import { ODataProvider } from "../../../contexts/ODataContext";
import { RoleService } from "../../../services/RoleService";
import DataGridCustom, { ColumnCustomProps, DataGridHandle } from "../../../components/DataGridCustom";
import { Link, useLocation } from "react-router-dom";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { Button } from "@progress/kendo-react-buttons";
import Modal from 'react-bootstrap/Modal';

const ManageUsers: React.FC = () => {

  const roleService = new RoleService();
  const commonLibrary = new CommonLibrary();
  const { t } = useTranslation();
  const location = useLocation();
  const { RoleId, Description } = location.state as any;
  const usersApi = config.API_URL + "/odata/Users/";
  const roleUsersApi = config.API_URL + "/odata/ProjectRoleUsers/";
  const dataGridUsersRef = useRef<DataGridHandle>(null);
  const dataGridRoleUsersRef = useRef<DataGridHandle>(null);
  const [selectedUserItems, setSelectedUserItems] = React.useState<number[]>([]);
  const [selectedRoleUserItems, setSelectedRoleUserItems] = React.useState<number[]>([]);
  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);  

  // Define the column menu
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };
  // Define the columns

  const columnsUsers = [] as ColumnCustomProps[];
  columnsUsers.push({ field: "Username", title: t("general.name"), columnMenu: ColumnMenu, isExportable: true }); 

  const columnsRoleUsers = [] as ColumnCustomProps[];
  columnsRoleUsers.push({ field: "UserName", title: t("general.name"), columnMenu: ColumnMenu, isExportable: true });  
  

  // Define handles
  const onSelectedItemsChangeLabel = (selectedItems: number[]) => {
    setSelectedUserItems(selectedItems);
  }

  const onSelectedItemsChangeLabelEntity = (selectedItems: number[]) => {
    setSelectedRoleUserItems(selectedItems);
  }

  React.useEffect(() => {    
    dataGridRoleUsersRef.current?.filterData({
      logic: "and",
      filters: [
        {
          field: "RoleId",
          operator: "eq",
          value: RoleId
        }
      ]
    });   
  }, []);

  const handleAddUsersToRole = () => {
    if (selectedUserItems.length > 0) {      
      const roleModel = {
        ProjectId: commonLibrary.ProjectId,
        TargetId: RoleId,
        ObjectIds: selectedUserItems
      };
      roleService.AddUsersToRole(roleModel).then(() => {
        dataGridRoleUsersRef.current?.refreshData();
      });
    }
  }

  const handleRemoveUsersFromRole = () => {
    if(selectedRoleUserItems.length > 0){
      setShow(true);
  }
  }  

 const handleConfirm = () => {
  setShow(false);
  const roleModel = {
    ProjectId: commonLibrary.ProjectId,
    TargetId: RoleId,
    ObjectIds: selectedRoleUserItems
  };
  roleService.RemoveUsersFromRole(roleModel).then(() => {
    dataGridRoleUsersRef.current?.refreshData();
  });
 }

  return (
    <div>
      <Row className="pt-2">
        <Col sm={{ span: 2, offset: 10 }}>
          <Link className="btn" to="/roles">
             <SvgIcon className="btn-icons" icon={svgIcons.arrowLeftIcon} size="medium" /><Trans>general.returnToBack</Trans></Link>
        </Col>
      </Row>
      <div className="pt-2">
        <div className="tile-content">         
            <h5 className="title"><Trans>configuration.roles.manageUsersTo</Trans> {Description}</h5>
            <span className="subtitle"><Trans>configuration.roles.userManagementSubtitle</Trans></span>      
      <Row className="pt-2">
            <Col sm={12} className="content-labels">         
          <ODataProvider baseUrl={usersApi} loadingContent=".content-labels .k-grid-content">
            <DataGridCustom ref={dataGridUsersRef} DataItemKey="UserId" Columns={columnsUsers} onSelectedItemsChange={onSelectedItemsChangeLabel} PageSize={6} />
          </ODataProvider>
          </Col>
          </Row>
        </div>
      </div>
      <div className="pt-4">
        <div className="tile-content">    
      <Row className="content-entity-labels">
        <Col sm={12}>
          <ODataProvider baseUrl={roleUsersApi} loadingContent=".content-entity-labels .k-grid-content">
            <DataGridCustom PermissionButtonCode="configuration_roles_users" ShowAddButton={true} ShowRemoveButton={true} onAddButtonClick={handleAddUsersToRole} onRemoveButtonClick={handleRemoveUsersFromRole} ref={dataGridRoleUsersRef} DataItemKey="UserId" Columns={columnsRoleUsers} onSelectedItemsChange={onSelectedItemsChangeLabelEntity} PageSize={6}/>
          </ODataProvider>
        </Col>
      </Row>  
      </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title><Trans>general.titleRemoveMessage</Trans></Modal.Title>
        </Modal.Header>
        <Modal.Body><Trans>general.removeMessage</Trans></Modal.Body>
        <Modal.Footer>
          <Button themeColor="secondary" onClick={handleClose}>
            <Trans>general.cancel</Trans>
          </Button>
          <Button themeColor="primary" onClick={handleConfirm}>
          <Trans>general.ok</Trans>
          </Button>
        </Modal.Footer>
      </Modal> 
    </div>
  );
};

export default ManageUsers;
